import React from "react";
import ReactApexChart from "react-apexcharts";

function Chart({ paymentHistory }) {
  let paymentDates = [];
  let paymentReceived = [];

  for (let i = 0; i < paymentHistory.length; i++) {
    // Convert date to a valid JavaScript Date format
    const newDate = new Date(paymentHistory[i].datePaid);
    // Push the date as a timestamp (milliseconds since January 1, 1970)
    paymentDates.push(newDate.getTime());
    // Push the amount received
    paymentReceived.push(paymentHistory[i].amountPaid);
  }

  const series = [
    {
      name: "Payment Received",
      data: paymentReceived,
    },
  ];

  const options = {
    chart: {
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      type: "datetime", // Use datetime type for x-axis
      categories: paymentDates,
      labels: {
        // Format the x-axis labels as "dd/MM/yyyy"
        datetimeFormatter: {
          year: "yyyy",
          month: "MMM",
          day: "dd",
        },
      },
    },
    tooltip: {
      x: {
        format: "dd/MM/yyyy", // Format the tooltip date as "dd/MM/yyyy"
      },
    },
    plotOptions: {
      bar: {
        horizontal: false, // Set to true if you want horizontal bars
        columnWidth: 20, // Adjust this percentage to control bar width
        // You can also set a fixed pixel width for the bars, like: columnWidth: 30
      },
    },
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        textAlign: "center",
        width: "90%",
        margin: "10px auto",
        padding: "10px",
      }}
    >
      <br />
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={300}
      />
    </div>
  );
}

export default Chart;
